<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    lazy
    transition="scale-transition"
    offset-y
    full-width
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="schema.$value"
        prepend-icon="event"
        readonly
        clearable
        :label="schema.$schema.title"
        :error-messages="schema.$error ? [schema.$error] : []"
        @blur="schema.$hasFocus = false"
        v-on="on"
      />
    </template>

    <v-date-picker v-model="schema.$model" locale="pl-pl" :first-day-of-week="1" @input="menu = false" />
  </v-menu>
</template>

<script>
import moment from 'moment';

// @vuese
// @group Components/Forms
// Input na daty
export default {
  props: {
    schema: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      menu: false
    };
  },
  watch: {
    'schema.$model'(val) {
      if (val) {
        this.schema.$setData(moment(val).format('YYYY-MM-DD'));
      }
    }
  }
};
</script>
